

<p-sidebar [(visible)]="visible" position="right" [transitionOptions]="'.3s cubic-bezier(0, 0, 0.2, 1)'" styleClass="layout-config-sidebar w-18rem">

    
    <h5>Tema</h5>
    <div class="field-radiobutton">
        <p-radioButton 
            name="colorScheme" 
            value="light" 
            [(ngModel)]="layoutService.config().colorScheme" 
            inputId="mode-light" 
            (onClick)="changeColorScheme('light')">
        </p-radioButton>
        <label for="mode-light">Light</label>
    </div>
    <div class="field-radiobutton">
        <p-radioButton 
            name="colorScheme" 
            value="dim" 
            [(ngModel)]="layoutService.config().colorScheme" 
            inputId="mode-dim" 
            (onClick)="changeColorScheme('dim')">
        </p-radioButton>
        <label for="mode-dim">Dim</label>
    </div>
    <div class="field-radiobutton">
        <p-radioButton 
            name="colorScheme" 
            value="dark" 
            [(ngModel)]="layoutService.config().colorScheme" 
            inputId="mode-dark" 
            (onClick)="changeColorScheme('dark')">
        </p-radioButton>
        <label for="mode-dark">Dark</label>
    </div>
</p-sidebar>